module.exports = __webpack_public_path__ + "static/media/size-classic.f07a0044.svg";